/* Product Form */
if ( document.querySelector('.button--quote') ) {
    const quoteButton = document.querySelector('.button--quote');
    const contactInformation = document.querySelector('.contact');
    quoteButton.addEventListener( 'click', (e) => {
      e.preventDefault();
      quoteButton.classList.add('hidden');
      contactInformation.classList.remove('hidden');
    })
  } 